/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhoneLaptop} from '@fortawesome/pro-duotone-svg-icons';

const EquipmentIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPhoneLaptop} {...props} />
);

export default EquipmentIcon;
